import { render, staticRenderFns } from "./DouYinRelease.vue?vue&type=template&id=a63a4e7e&scoped=true"
import script from "./DouYinRelease.vue?vue&type=script&lang=js"
export * from "./DouYinRelease.vue?vue&type=script&lang=js"
import style0 from "./DouYinRelease.vue?vue&type=style&index=0&id=a63a4e7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63a4e7e",
  null
  
)

export default component.exports